<script>
  import { pwaDeferredPrompt } from "../utils/pwdStore";

  function handleInstall(event) {
    event.preventDefault();
    pwaDeferredPrompt.update((s) => event);
  }
</script>

<svelte:window on:beforeinstallprompt={handleInstall} />
